// import React, { useRef } from "react";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Pagination, Switch } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { INotificationTemplate } from '../../../api/notificationTemplate/notificationTemplateApi';
import { NodataTable } from '../../../components/NoDataTable';
import useToast from '../../../hook/useToast';
import { CHANNELTYPE } from '../../../services/data';
import { formatNumber } from '../../../services/mixin';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { checkDisabledPermission, dataPagination, getUserPermissions } from '../../../until';
import { IPagination } from '../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
// import EmptyComponentLinkText from '../../../components/EmptyComponent/EmptyComponentLinkText';
// const listNotificationZNS = [
//   {
//     id: 1,
//     title: 'Tích luỹ điểm thưởng',
//     typeTagDefault: 'ZNS01',
//     typeTag: 'Khuyến mãi',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns.svg'
//   },
//   {
//     id: 2,
//     title: 'Lấy lại mật khẩu',
//     typeTagDefault: 'ZNS02',
//     typeTag: 'Thông báo',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns-2.svg'
//   },
//   {
//     id: 3,
//     title: 'Báo trạng thái đơn hàng',
//     typeTagDefault: 'ZNS03',
//     typeTag: 'Thông báo',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns-3.svg'
//   },
//   {
//     id: 4,
//     title: 'Báo trạng thái đơn hàng',
//     typeTagDefault: 'ZNS03',
//     typeTag: 'Thông báo',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns-3.svg'
//   },
//   {
//     id: 5,
//     title: 'Chương trình khuyến mãi mới',
//     typeTagDefault: 'ZNS04',
//     typeTag: 'Thông báo',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns.svg'
//   },
//   {
//     id: 6,
//     title: 'Báo phí dịch vụ',
//     typeTagDefault: 'ZNS05',
//     typeTag: 'Tiếp thị',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns-3.svg'
//   },
//   {
//     id: 7,
//     title: 'Báo phí dịch vụ',
//     typeTagDefault: 'ZNS05',
//     typeTag: 'Tiếp thị',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns-3.svg'
//   },
//   {
//     id: 8,
//     title: 'Rating',
//     typeTagDefault: 'ZNS06',
//     typeTag: 'CSKH',
//     typestatus: 'Chờ quản lý duyệt',
//     img: '/images/exportImg/img-zns-4.svg'
//   }
// ]



export interface ZnsTemplateRow {
  id: number;
  code: string;
  name: string;
  brand: string;
  znsType: string;
  costType: string;
  creator: string;
  createdAt: string;
  isActive: boolean;
}
interface Props {
  paginations: Record<CHANNELTYPE, IPagination>
  dataTemplates: Record<CHANNELTYPE, INotificationTemplate[]>
  gInfoNotificationTemplate: (id: number) => void
  uStatusNotificationTemplate: (id: number) => void
  openModalDelete: (id: number) => void
  onPaginationChange: ((page: number, pageSize: number) => void)
}
const ZNS: React.FC<Props> = ({
  paginations, dataTemplates,
  gInfoNotificationTemplate, uStatusNotificationTemplate, openModalDelete, onPaginationChange
}) => {
  const navigate = useNavigate()
  const pushToast = useToast()

  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)


  const columnDefs = useMemo<ColDef<any>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'action',
      colId: 'action',
      width: 203,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },

      cellRenderer: (params: ICellRendererParams) => {
        const { id, view, status } = params.data;
        return (
          <div className="h-full d-flex align-center justify-center gap-10-px">
            <EyeOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() => { gInfoNotificationTemplate(id) }}
            />
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() =>
                navigate(`/marketing/notification-templates-management/editzns`,
                  {
                    state: {
                      id: id,
                      type: CHANNELTYPE.ZNS
                    }
                  })}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
              onClick={() => openModalDelete(id)}
            />
            <Switch
              disabled={!edit}
              checked={status}
              onChange={() => {
                uStatusNotificationTemplate(Number(id));
              }}
              className="rs-switch rs-switch--sm"
            />
          </div>
        );
      }
    },
    {
      headerName: "Mã mẫu",
      field: "code",
      sortable: true,
    },
    {
      headerName: "Tên mẫu thông báo",
      field: "title",
    },
    {
      headerName: "Đơn vị / thương hiệu",
      field: "categories",
    },
    {
      headerName: "Loại ZNS",
      field: "typeZNSName",
    },
    {
      headerName: "Chi phí dự kiến / mẫu",
      field: "costType",
    },
    {
      headerName: "Người tạo",
      field: "adminName",
    },
    {
      headerName: "Ngày tạo",
      field: "createdAt",
      sortable: true,
    },

  ], []); // Chỉ các hàm setState

  return (
    <div className=''>

      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid" getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataTemplates[CHANNELTYPE.ZNS]}
            rowHeight={55}
            columnDefs={columnDefs}

            // rowSelection="multiple"
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={paginations[CHANNELTYPE.ZNS].current} pageSize={paginations[CHANNELTYPE.ZNS].pageSize} total={paginations[CHANNELTYPE.ZNS].total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(paginations[CHANNELTYPE.ZNS].total, paginations[CHANNELTYPE.ZNS].pageSize,
                paginations[CHANNELTYPE.ZNS].current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
    </div>
  )
}

export default ZNS
